export * from 'inpc/selectors/inpc_selectors';



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/selectors/index.js